/**
 * Next.js 16 + Turbopack (dev): internal `performance.measure` can throw when a route
 * redirects or 404s before render marks complete. Harmless — suppress in development only.
 * @see https://github.com/vercel/next.js/issues/86060
 */
export function patchPerformanceMeasureForDev(): void {
  if (process.env.NODE_ENV === 'production') return;

  const perf = globalThis.performance;
  if (!perf?.measure || (perf as Performance & { __nextMeasurePatched?: boolean }).__nextMeasurePatched) {
    return;
  }

  const original = perf.measure.bind(perf);

  perf.measure = function measurePatched(
    measureName: string,
    startOrMeasureOptions?: string | PerformanceMeasureOptions,
    endMark?: string,
  ): PerformanceMeasure {
    try {
      return original(measureName, startOrMeasureOptions as PerformanceMeasureOptions, endMark);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      const name = err instanceof Error ? err.name : '';
      if (
        message.includes('negative time stamp') ||
        name === 'InvalidAccessError' ||
        name === 'SyntaxError'
      ) {
        return undefined as unknown as PerformanceMeasure;
      }
      throw err;
    }
  };

  (perf as Performance & { __nextMeasurePatched?: boolean }).__nextMeasurePatched = true;
}
